import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { useT } from "@/i18n/LocaleContext";

export default function Standards() {
  const { t, dict } = useT();
  const cards = dict.standards.cards;

  return (
    <section id="normen" className="py-32 lg:py-44 bg-white" data-testid="standards-section">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-16 lg:mb-20 max-w-3xl"
        >
          <p className="font-tech text-[11px] tracking-[0.3em] uppercase text-[var(--ci-blue)] mb-6">{t("standards.eyebrow")}</p>
          <h2 className="text-3xl lg:text-5xl font-bold tracking-tight text-[var(--ci-grey)]">
            {t("standards.title1")}<span className="text-[var(--ci-blue)]">{t("standards.title2")}</span>
          </h2>
          <p className="mt-7 text-base sm:text-lg text-[var(--ci-grey)] leading-relaxed">
            {t("standards.copy")}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((c, i) => (
            <motion.article
              key={c.code}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.08 }}
              className="group relative border border-[#E3E8EC] rounded-2xl p-8 lg:p-10 bg-[#F7F9FA] hover:border-[var(--ci-turquoise)]/50 hover:bg-white hover:-translate-y-1 hover:shadow-[0_20px_60px_rgba(0,91,234,0.08)] transition-all duration-300"
              data-testid={`standard-card-${c.code.replace(/[^\w]/g, "-")}`}
            >
              <div className="flex items-start justify-between gap-4">
                <span className="w-11 h-11 rounded-xl bg-white border border-[#E3E8EC] text-[var(--ci-blue)] flex items-center justify-center shrink-0 group-hover:bg-[var(--ci-blue)] group-hover:text-white group-hover:border-[var(--ci-turquoise)] transition-colors duration-300">
                  <ShieldCheck size={20} />
                </span>
                <span className="font-tech text-[10px] tracking-[0.22em] uppercase text-[var(--ci-blue)]">{c.code}</span>
              </div>
              <h3 className="mt-6 text-lg sm:text-xl font-semibold tracking-tight text-[var(--ci-grey)]">{c.title}</h3>
              <p className="mt-3 text-sm text-[var(--ci-grey)] leading-relaxed">{c.desc}</p>
            </motion.article>
          ))}
        </div>

        <p className="mt-12 text-xs sm:text-sm text-[var(--ci-grey)] max-w-3xl leading-relaxed border-l-2 border-[var(--ci-blue)] pl-5">
          {t("standards.note")}
        </p>
      </div>
    </section>
  );
}
